import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg, money } from "@/lib/api";
import { ADMIN_EXTRA as T } from "@/constants/testIds";

const Stat = ({ label, value, testId }) => (
  <div className="bg-white border border-[#F0EBE1] rounded-2xl p-4">
    <p className="text-xs text-stone-500">{label}</p>
    <p data-testid={testId} className="mt-1 font-heading text-2xl font-extrabold">{value}</p>
  </div>
);

export const AdminWeeklyReport = () => {
  const [r, setR] = useState(null);
  const [html, setHtml] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/weekly-report").then(({ data }) => setR(data)).catch((e) => toast.error(errMsg(e)));
    api.get("/admin/weekly-report/preview", { responseType: "text" }).then(({ data }) => setHtml(data)).catch(() => {});
  }, []);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/weekly-report/send"); toast.success(`Sent to ${data.to}`); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (!r) return <p className="mt-6 text-stone-500">Loading last week's numbers…</p>;
  const low = r.margin_alerts.products;
  return (
    <section data-testid={T.weekly} className="mt-6 space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-stone-600">
          Every Monday morning we email <strong data-testid={T.weeklyTo}>{r.send_to}</strong> the numbers for {r.week_start} to {r.week_end}.
          {r.last_sent && <> Last automatic email: {new Date(r.last_sent).toLocaleDateString()}.</>}
        </p>
        <button data-testid={T.weeklySend} disabled={busy} onClick={send} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1C1917] text-white text-sm hover:bg-[#E06D44] disabled:opacity-50 transition-colors">
          <Mail size={15} /> {busy ? "Sending…" : "Email me this now"}
        </button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat label="Sales last week" value={money(r.sales)} testId={T.weeklySales} />
        <Stat label="Orders" value={r.orders} testId={T.weeklyOrders} />
        <Stat label="Average order" value={money(r.avg_order)} />
        <Stat label="Waiting to ship" value={r.to_ship} />
      </div>
      <p data-testid={T.weeklyAlerts} className={`text-sm rounded-2xl p-3 ${low.length ? "bg-amber-50 text-amber-900" : "bg-[#E8F0EB] text-[#4E7B68]"}`}>
        {low.length ? `${low.length} product(s) below your ${r.margin_alerts.threshold}% margin alert: ${low.map((p) => `${p.name} (${p.margin}%)`).join(", ")}` : `No products below your ${r.margin_alerts.threshold}% margin alert.`}
      </p>
      {html && <iframe data-testid={T.weeklyPreview} title="Weekly email preview" srcDoc={html} sandbox="" className="w-full h-[640px] rounded-2xl border border-[#F0EBE1] bg-white" />}
    </section>
  );
};
